<mat-toolbar class="page-header">
  <div class="menu-container">
    <div class="pg-title">Partner Platform - Partners</div>

    <div class="filter-container">
      <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
        <input
          (ngModelChange)="searchText = $event; searchChange.next()"
          [ngModel]="searchText"
          autocomplete="off"
          matInput
          placeholder="Search here..."
        />
        <button
          (click)="resetTextFilter()"
          *ngIf="searchText"
          class="clear-field-btn"
          mat-icon-button
          matSuffix
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" class="pg-filter" floatLabel="never">
        <mat-select
          (ngModelChange)="selectedPartnerStatusList = $event; filter()"
          [ngModel]="selectedPartnerStatusList"
          multiple
        >
          <mat-select-trigger>
            {{ getPolicyStatusDisplay() }}
          </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search
              (ngModelChange)="filterPolicyStatusSelection($event)"
              (toggleAll)="toggleSelectAllPolicyStatus($event)"
              [ngModelOptions]="{ standalone: true }"
              [searching]="!partnerStatusList.length"
              [showToggleAllCheckbox]="true"
              [toggleAllCheckboxChecked]="isSelectedAllPolicyStatus()"
              [toggleAllCheckboxIndeterminate]="isIndeterminatePolicyStatus()"
              ngDefaultControl
              ngModel
              noEntriesFoundLabel="No matching partner statuses"
              placeholderLabel="Search partner status..."
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let item of filterPartnerStatusList"
            [value]="item.id"
          >
            {{ item.name }}
          </mat-option>
        </mat-select>
        <button
          (click)="resetPolicyStatus()"
          *ngIf="!isSelectedAllPolicyStatus()"
          class="clear-field-btn"
          mat-icon-button
          matSuffix
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  </div>
</mat-toolbar>

<div class="content-container">
  <div class="pb-sm" fxLayout="row" fxLayoutGap="16px">
    <div class="partner-card">
      <div class="partner-card__title">Total Partners</div>
      <div style="color: #101828">{{ summaryCount?.totalPartners }}</div>
    </div>

    <div class="partner-card">
      <div class="partner-card__title">Active</div>
      <div style="color: #00a63e">{{ summaryCount?.activeCount }}</div>
    </div>

    <div class="partner-card">
      <div class="partner-card__title">Inactive</div>
      <div style="color: #f54900">{{ summaryCount?.inactiveCount }}</div>
    </div>

    <div class="partner-card" style="visibility: hidden"></div>
  </div>

  <div class="pb-sm" fxLayoutAlign="end center">
    <div>
      <button
        (click)="addPartner()"
        class="mr-sm"
        color="primary"
        mat-flat-button
      >
        + Add New Partner
      </button>
      <button (click)="exportPolicies()" color="primary" mat-stroked-button>
        Export data
      </button>
    </div>
  </div>

  <mat-card class="card-table">
    <table
      (matSortChange)="sortChange($event)"
      [dataSource]="dataSource"
      mat-table
      matSort
      matSortActive="date"
      matSortDirection="desc"
      matSortDisableClear
    >
      <ng-container matColumnDef="date">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Date Added</th>
        <td
          *matCellDef="let element; dataSource: dataSource"
          [copyValue]="element.createdDate | date : 'dd MMM yyyy'"
          mat-cell
        >
          {{ (element.createdDate | date : "dd MMM yyyy") || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="partnerName">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Partner Name</th>
        <td
          *matCellDef="let element; dataSource: dataSource"
          [copyValue]="element.partnerName || ''"
          mat-cell
        >
          {{ element.partnerName || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="registrationNo">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          Registration No.
        </th>
        <td
          *matCellDef="let element; dataSource: dataSource"
          [copyValue]="element.registrationNo || ''"
          mat-cell
        >
          {{ element.registrationNo || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Category</th>
        <td
          *matCellDef="let element; dataSource: dataSource"
          [copyValue]="element.category || ''"
          mat-cell
        >
          {{ element.category || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="protections">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Protections</th>
        <td *matCellDef="let element; dataSource: dataSource" mat-cell>
          {{ element.protection || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="branches">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Branches</th>
        <td *matCellDef="let element; dataSource: dataSource" mat-cell>
          {{ element.branch || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th *matHeaderCellDef mat-header-cell>Status</th>
        <td *matCellDef="let element; dataSource: dataSource" mat-cell>
          <span
            *ngIf="element.status === PartnerStatus.Active"
            class="cover-label green"
            >Active</span
          >
          <span
            *ngIf="element.status === PartnerStatus.Inactive"
            class="cover-label grey"
            >Inactive</span
          >
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let element; dataSource: dataSource" mat-cell>
          <button
            (click)="selected = element"
            [matMenuTriggerData]="{ element }"
            [matMenuTriggerFor]="menu"
            mat-icon-button
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>

      <tr *matNoDataRow>
        <td class="mat-cell" colspan="9999">
          <div
            *ngIf="!isLoading && dataSource.length === 0"
            class="mv-lg"
            fxLayout="column"
            fxLayoutAlign="center center"
          >
            <img
              alt=""
              src="https://storage.googleapis.com/dev-ps-asset/ps_icons/no-record-found.png"
            />
            <div class="fs-lg color-muted">No partners found</div>
          </div>
          <ngx-skeleton-loader
            *ngIf="isLoading"
            [theme]="{
              height: '40px',
              'animation-duration': '1s'
            }"
            count="3"
          >
          </ngx-skeleton-loader>
        </td>
      </tr>
    </table>

    <mat-divider></mat-divider>

    <mat-paginator
      #paginator
      (page)="pageChange($event)"
      [length]="length"
      [pageSizeOptions]="[50, 100, 150]"
      [pageSize]="limit"
    ></mat-paginator>
  </mat-card>
</div>

<mat-menu #menu="matMenu">
  <ng-template let-element="element" matMenuContent>
    <button (click)="viewDetails(element)" mat-menu-item>View Details</button>
  </ng-template>
</mat-menu>
